import { Button } from '../../../cdl/Button/Button';
import { Modal } from '../../../cdl/Modal/Modal';
import { Text } from '../../../cdl/Text/Text';
import { ButtonGroup } from '../../../common/buttons/ButtonGroup';
import { translate } from '../../../common/helpers/translate.helper';
import { Box } from '../../../common/ui/Box';

interface ContractDeactivateConfirmModalProps {
    isOpen: boolean;
    isSubmitting?: boolean;
    onConfirm: () => void;
    onDismiss: () => void;
}

export const ContractDeactivateConfirmModal = ({
    isOpen,
    isSubmitting = false,
    onConfirm,
    onDismiss,
}: ContractDeactivateConfirmModalProps) => {
    return (
        <Modal isOpen={isOpen} onDismiss={onDismiss} scrollable={false} dismissible={false}>
            <Box padding={24} display="grid" rowGap={16}>
                <Text variant="title">{translate('contracts.actions.deactivate.confirmTitle')}</Text>
                <Text>{translate('contracts.actions.deactivate.confirmDescription')}</Text>
                <ButtonGroup justifyContent="flex-end">
                    <Button type="button" onClick={onDismiss} disabled={isSubmitting}>
                        {translate('btn.cancel')}
                    </Button>
                    <Button emphasis="high" destructive type="button" onClick={onConfirm} isLoading={isSubmitting}>
                        {translate('contracts.actions.deactivate.contractLabel')}
                    </Button>
                </ButtonGroup>
            </Box>
        </Modal>
    );
};
